import TermsAndConditions from '@mfe-presentation/components/TermsAndConditions';
import FieldsetWrapper from '@mfe-presentation/components/Wrappers/FieldsetWrapper';
import FieldWrapper from '@mfe-presentation/components/Wrappers/FieldWrapper';
import { useAppContext } from '@mfe-presentation/contexts';
import { TStyleProps } from '@mfe-types/box';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';
import { isFrenchPortal } from '@mfe-helpers/portalHelpers';

const phoneNumberContainerStyles: TStyleProps = {
    display: 'flex',
    flexDirection: 'row',
};

const phoneNumberRegionCodeStyles: TStyleProps = {
    marginRight: 'spacing.8',
    width: '105px',
};

const phoneNumberStyles: TStyleProps = {
    maxWidth: 'calc(100% - 105px - 8px)',
};

const Identity = () => {
    const { formValues, config, portal } = useAppContext();
    const { t } = useTranslation(NAME_SPACE);

    const fields = config.identity.getFields(formValues);

    return (
        <>
            <FieldWrapper name="salutation" field={fields.salutation} />
            <FieldWrapper name="firstName" field={fields.firstName} />
            <FieldWrapper name="lastName" field={fields.lastName} />
            <FieldsetWrapper
                name="phoneInformation"
                legendTitle={t('step_identity.fieldsets.phoneInformation.legend')}
                styles={phoneNumberContainerStyles}
            >
                <FieldWrapper
                    name="phoneNumberRegionCode"
                    styles={phoneNumberRegionCodeStyles}
                    field={fields.phoneNumberRegionCode}
                />
                <FieldWrapper
                    name="phoneNumber"
                    styles={phoneNumberStyles}
                    field={fields.phoneNumber}
                />
            </FieldsetWrapper>
            <FieldWrapper name="email" field={fields.email} />

            <TermsAndConditions />

            {isFrenchPortal(portal) && (
                <FieldWrapper
                    name="hasRejectedEmailMarketingCommunications"
                    field={fields.hasRejectedEmailMarketingCommunications}
                    translationParams={{ portal }}
                />
            )}
        </>
    );
};

export default Identity;
